import { useRounds } from "../../api/rounds";
import { createRoundsStatusFilter } from "../utils/createRoundsStatusFilter";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { getAlloVersion } from "common/src/config";
export let RoundStatus = /*#__PURE__*/function (RoundStatus) {
  RoundStatus["active"] = "active";
  RoundStatus["taking_applications"] = "taking_applications";
  RoundStatus["finished"] = "finished";
  RoundStatus["ending_soon"] = "ending_soon";
  return RoundStatus;
}({});
export const ACTIVE_ROUNDS_FILTER = {
  orderBy: "MATCH_AMOUNT_IN_USD_DESC",
  status: `${RoundStatus.active},verified`,
  type: "allov2.DonationVotingMerkleDistributionDirectTransferStrategy,allov1.QF",
  network: ""
};
export const ROUNDS_ENDING_SOON_FILTER = {
  first: 3,
  orderBy: "DONATIONS_END_TIME_ASC",
  type: "",
  network: "",
  status: `${RoundStatus.ending_soon},verified`
};
export const useFilterRounds = (where, chains, onlywWhitelistedPrograms) => {
  const chainIds = where.network === undefined || where.network.trim() === "" ? chains.map(c => c.id) : where.network.split(",").map(id => parseInt(id));
  const statusFilter = useMemo(() => createRoundsStatusFilter(where.status), [where.status]);
  const strategyNames = where.type === undefined || where.type.trim() === "" ? [] : where.type.split(",");
  const alloVersion = getAlloVersion();
  const statuses = where.status.split(",");
  const filter = createRoundWhereFilter(statusFilter, strategyNames, chainIds, statuses.includes(RoundStatus.finished) && alloVersion === "allo-v2" ? undefined : alloVersion);
  const orderBy = where.orderBy === undefined ? "CREATED_AT_BLOCK_DESC" : where.orderBy;
  const vars = {
    orderBy,
    filter
  };
  return useRounds(vars, chainIds, onlywWhitelistedPrograms);
};
const createRoundWhereFilter = (statusFilter, strategyNames, chainIds, version) => {
  return {
    // @ts-expect-error TS thinks that some of the items can be undefined,
    // even though they can't, because they are filtered out down the line
    // so we ignore the error here
    _and: [
    // Find rounds that match both statusFilter and round type
    {
      _or: statusFilter
    }, {
      ...(strategyNames.length > 0 && {
        _or: {
          strategyName: {
            _in: strategyNames
          }
        }
      })
    }, {
      ...(chainIds.length > 0 && {
        _or: {
          chainId: {
            _in: chainIds
          }
        }
      })
    }, {
      ...(version && {
        _or: {
          tags: {
            _contains: version
          }
        }
      })
    }].filter(prop => !isEmpty(prop)).filter(prop => prop !== undefined)
  };
};
export const getRoundSelectionParamsFromUrlParams = params => {
  // TODO parse url params explicitly
  return Object.fromEntries(params);
};